var exports = {
  "mc": "Container__csTGW7",
  "sx": "Draggable__6L8EpJ",
  "DZ": "Heading__CXOPEl",
  "n2": "ColumnTitleWithWorkflowIndicator__epH_lE",
  "Zp": "AggregateLabels__gtilgV",
  "FM": "CurrentIterationLabel__SqiG28",
  "II": "ColumnActions__qozKJz",
  "w9": "Box_3__a1-A38",
  "P_": "SanitizedHtml__-NmHhQ",
  "pQ": "Box_4__sOX6-Z",
  "$n": "Button__fedR8S",
  "Ax": "ColumnFrame__j2Hd3L",
  "Ds": "StyledPlaceholder__uT31br",
};

module.exports = exports;
